import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../service/apiEndPoints";
import { ProfilePayload, Profile } from "../../types";

// Fetch profile
export const fetchProfile = createAsyncThunk<
  Profile,
  void,
  { rejectValue: string }
>("profile/fetchProfile", async (_, { rejectWithValue }) => {
  try {
    const response = await api.profileAPi();
    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(error.message || "API Error");
  }
});

// Edit profile
export const editProfileThunk = createAsyncThunk<
  Profile,
  ProfilePayload,
  { rejectValue: string }
>("profile/editProfile", async (payload, { rejectWithValue }) => {
  try {
    const response = await api.editProfileAPI(payload);
    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Edit Failed");
  }
});

export const fetchGSTDetailsThunk = createAsyncThunk(
  "register/fetchGSTDetails",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await api.fetchGSTDetailsAPI(payload);
      return response?.data?.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.response?.data?.errors?.[0] ||
          "Failed to Fetch GST Details",
      );
    }
  },
);

export const submitUserRegistrationDetailsThunk = createAsyncThunk(
  "register/submitUserDetails",
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.submitUserRegistrationDetailsAPI(payload);
      return response?.data?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          error?.response?.data?.errors?.[0] ||
          error.message ||
          "Submit Failed",
      );
    }
  },
);
